<template>
  <div v-loading="loading">
    <div class="form-group">
      <template v-if="changeKey">
        <label>{{ $tc('Keys', 1) }}</label>
        <input
          v-model="model.key"
          type="text"
          class="form-control"
          required
          @change="updated"
        >
      </template>
      <template v-else>
        {{ $tc('Keys', 1) }}: <b>{{ model.key }}</b>
      </template>
    </div>
    <div class="form-group">
      <label>{{ $t('Name') }}</label>
      <input
        v-model="model.name"
        type="text"
        required
        minlength="1"
        maxlength="255"
        class="form-control"
        @change="updated"
      >
    </div>
    <div class="form-group">
      <label>{{ $t('Description') }}</label>
      <textarea
        v-model="model.description"
        class="form-control textarea"
        @change="updated"
      />
    </div>
    <div class="form-group">
      <label>{{ $t('Default value') }} <a
        href="https://twig.symfony.com/doc/2.x/"
        target="_blank"
      ><i class="fa fa-question-circle" /></a></label>
      <textarea
        v-model="model.default"
        class="form-control textarea"
        @change="updated"
      />
    </div>
    <div class="form-group">
      <label>{{ $tc('Types', 1) }} </label>
      <select
        v-model="model.type"
        class="form-control"
        @change="updated"
      >
        <option
          v-for="(type, typeId) in types"
          :key="typeId"
          :value="typeId"
        >
          {{ type }}
        </option>
      </select>
    </div>
    <ui-checkboxes
      v-if="Object.keys(availableAttributes).length > 0"
      v-model="attributesModel"
      :options="availableAttributes"
      :label="$tc('Attributes', 2)"
      @change="updatedAttributes"
    />
    <div class="form-group">
      <input
        id="templates-form-required"
        v-model="model.required"
        type="checkbox"
        @change="updated"
      >
      <label for="templates-form-required">{{ $t('Required') }}?</label>
    </div>
  </div>
</template>

<script>
import MarketplaceTemplateService from '../../services/MarketplacesTemplatesService';

export default {
  name: 'AppTemplateForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    marketplaceId: {
      type: Number,
      required: true,
    },
    changeKey: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: {},
      availableAttributes: {},
      attributesModel: {},
      loading: false,
    };
  },
  computed: {
    types() {
      return { field: this.$tc('Fields', 1), attribute: this.$tc('Attributes', 1) };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        const isAttributesChanged = typeof this.model.attributes === 'undefined' || !(this.model.attributes.length === v.attributes.length && this.model.attributes.sort().every((value, index) => value === v.attributes.sort()[index]));
        this.model = v;
        if (typeof this.model.type !== 'undefined' && this.model.type === 'field' && isAttributesChanged) {
          // Loading available attributes
          this.loading = true;
          MarketplaceTemplateService.findAttributesByKey(this.marketplaceId, v.key).then(data => {
            if (data.length > 0) {
              const attributesModel = {};
              const availableAttributes = {};
              data.forEach(e => {
                attributesModel[e.key] = this.model.attributes.indexOf(e.key) !== -1;
                availableAttributes[e.key] = e.key;
              });
              this.attributesModel = attributesModel;
              this.availableAttributes = availableAttributes;
            }
            this.loading = false;
          }).catch(() => {
            this.$errors_showNetworkErrorMessage();
            this.loading = false;
          });
        }
      },
    },
  },
  methods: {
    updated() {
      this.$emit('input', this.model);
    },
    updatedAttributes(v) {
      const attributes = [];
      if (Object.keys(v).length > 0) {
        Object.keys(v).forEach(key => {
          if (v[key] === true) {
            attributes.push(key);
          }
        });
      }
      const model = { ...this.model };
      model.attributes = attributes;
      this.model = model;
      this.$emit('input', model);
    },
  },
};
</script>
